import { observable
       , IObservableValue }       from 'mobx' ;

import { kde_api_logged_user_t }  from './01_api_types' ;


let g_auth_token: IObservableValue< string > = observable.box( '' )
  , g_user     : IObservableValue< kde_api_logged_user_t | null > = observable.box( null )
  , g_loading  : IObservableValue< boolean > = observable.box( true ) ;

const JMA_USER  = 'jma_user'
    , JMA_TOKEN = 'jma_token' ;


export async function init ( )
{
  const stored_user = JSON.parse( localStorage.getItem( JMA_USER ) || 'null' ) as kde_api_logged_user_t | null ;

  g_user.set( stored_user ) ;
  g_auth_token.set( localStorage.getItem( JMA_TOKEN ) || '' ) ;

  g_loading.set( false ) ;
}


export function auth_token ( )
{
  return g_auth_token.get( ) ;
}


export function auth_is_loading ( )
{
  return g_loading.get( ) ;
}


export function logged_user ( )
{
  return g_user ;
}

type on_user_changed_callback = ( user: kde_api_logged_user_t | null ) => void ;
const g_user_change_callbacks: on_user_changed_callback[] = [] ;

export function set_user ( user: kde_api_logged_user_t | null, token: string )
{
  g_user.set( user ) ;
  g_auth_token.set( token ) ;

  localStorage.setItem( JMA_USER , JSON.stringify( user || null ) ) ;
  localStorage.setItem( JMA_TOKEN, token ) ;

  g_user_change_callbacks.forEach( cb => cb( user ) ) ;
}


export function on_user_changed ( cb: on_user_changed_callback )
{
  g_user_change_callbacks.push( cb ) ;
}


export function is_logged ( )
{
  return !!g_user.get( ) && g_auth_token.get( ).length > 0 ;
}


export function logout ( )
{
  set_user( null, '' ) ;
}